import {Logger} from '@vanti/vue-logger';
import {PanelLightsCrestron} from '@/api/panel-lights-crestron';
import {PanelLightsQbic} from '@/api/panel-lights-qbic';
import {PanelLightsIadea} from '@/api/panel-lights-iadea';
import {minutes} from '@/utils/dates';

const log = Logger.get('panel-lights');

let ledCheckInterval;

export default store => {
  /**
   * @type {PanelLights}
   */
  let panelLights;
  /**
   * @type {string|undefined|null}
   */
  let panelType = null;

  // watch for changes to the room state and set the panel lights to match
  // when running on localhost this will skip the API call
  store.watch(
      (state, getters) => getters['room/roomState'],
      state => {
        log.debug('room state change to:', state);
        if (panelLights) {
          panelLights.onRoomStateChange(state).catch(log.error);
        }
      },
      {
        immediate: true
      }
  );

  // watch for changes to the panelType
  store.watch(
      (state, getters) => getters['config/panelType'],
      type => {
        log.debug('panel type change to:', type);
        if (type !== panelType) {
          panelType = type;
          if (panelType === 'iadea') {
            panelLights = new PanelLightsIadea(store, store.getters['config/panelApiPw']);
          } else if (panelType === 'crestron') {
            panelLights = new PanelLightsCrestron(store);
          } else {
            panelLights = new PanelLightsQbic(store);
          }
          panelLights.onRoomStateChange(store.getters['room/roomState']).catch(log.error);
        }
      },
      {
        immediate: true
      }
  );

  const isLocal = location.hostname === 'localhost';
  if (isLocal) {
    log.debug(`skipping setting up LED check`);
    return;
  }
  if (ledCheckInterval) {
    log.debug('led check already running');
    return;
  }
  log.debug(`setting up LED check`);
  /**
   * every 5 minutes check the LED status is correct
   */
  ledCheckInterval = setInterval(() => {
    if (panelLights) {
      panelLights.runLedCheck();
    }
  }, 5 * minutes);
};
